module.exports = __webpack_public_path__ + "static/404-f18795250deaede8beb454e2c31724b8.gif";